import { render, staticRenderFns } from "./ComboField.vue?vue&type=template&id=04b2e826"
import script from "./ComboField.vue?vue&type=script&lang=js"
export * from "./ComboField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports